var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddtowishlist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55883 4.72796L7.9965 5.54903L8.43969 4.73092C8.85932 3.95632 9.51335 3.5 10.3418 3.5C11.7138 3.5 12.8334 4.60315 12.8334 6.30266C12.8334 8.35768 11.1214 10.5164 8.12742 12.4673C8.08629 12.4916 8.04305 12.5138 8.00629 12.5287C8.00423 12.5295 8.00225 12.5303 8.00035 12.531C7.99897 12.5305 7.99754 12.5299 7.99607 12.5293C7.95994 12.5145 7.91844 12.4926 7.88255 12.4702C4.88035 10.5185 3.16673 8.35862 3.16673 6.30266C3.16673 4.60315 4.28637 3.5 5.65833 3.5C6.48815 3.5 7.15109 3.96304 7.55883 4.72796Z",
    fill: "white",
    stroke: "#1A1A1A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtowishlist);
export default __webpack_public_path__ + "static/media/addtowishlist.c42d44518452d669cbd691bf66c78c31.svg";
export { ForwardRef as ReactComponent };